import { Flex } from "antd"
import React, { type ReactNode } from "react"

/** Purely decorative accent palette shared by card headers and stat tiles. */
const OVERVIEW_ACCENTS = {
  blue: { color: "#0284C7", background: "var(--dk-info-bg, #E6F6FE)" },
  green: { color: "#16A34A", background: "var(--dk-success-bg, #ECF9EF)" },
  orange: { color: "#FF8A3D", background: "var(--dk-warning-bg, #FFF1E8)" },
  indigo: { color: "#6366F1", background: "var(--dk-info-bg, #EEF0FE)" },
  teal: {
    color: "var(--dk-primary-text, #2A7D8C)",
    background: "var(--dk-selected, #E7F3F1)"
  }
} as const

type OverviewAccent = keyof typeof OVERVIEW_ACCENTS

function OverviewCardIcon({
  icon,
  accent,
  size = 28
}: {
  icon: ReactNode
  accent: OverviewAccent
  size?: number
}) {
  const { color, background } = OVERVIEW_ACCENTS[accent]

  return (
    <Flex
      align={"center"}
      justify={"center"}
      className={"rounded-full shrink-0"}
      style={{ color, background, width: size, height: size }}
    >
      {icon}
    </Flex>
  )
}

/** A card header's icon + label, paired with `ariaTitle` for `WorkspaceCard`'s ✎ button. */
function OverviewCardTitle({
  icon,
  accent,
  children
}: {
  icon: ReactNode
  accent: OverviewAccent
  children: ReactNode
}) {
  return (
    <Flex align={"center"} gap={8}>
      <OverviewCardIcon icon={icon} accent={accent} size={22} />
      <span>{children}</span>
    </Flex>
  )
}

export {
  type OverviewAccent,
  OVERVIEW_ACCENTS,
  OverviewCardIcon,
  OverviewCardTitle
}
